"use client";
import { FC, useContext } from "react";
import { BuilderBlockProps, BuilderProps } from "@solarwinds-webbiz/types";
import ItGlossary, {
  GlossaryEntry,
  GlossaryTableHeaders,
} from "@/components/ITGlossary/ITGlossary";
import { IndexCardsContext } from "./Index/IndexContextBlock";
import { getHrefFromCustomUrlPlugin } from "@/helpers";

export type ITGlossaryBlockProps = {
  glossaryTableHeaders: {
    label: string;
    dlt: string;
    dld: string;
  }[];
} & BuilderBlockProps &
  Pick<BuilderProps, "builderBlock">;

export const ITGlossaryBlock: FC<ITGlossaryBlockProps> = ({
  glossaryTableHeaders,
}) => {
  const { cards } = useContext(IndexCardsContext);

  if (!cards || cards.length === 0) {
    return null;
  }
  const tableHeaders: GlossaryTableHeaders = Array.isArray(glossaryTableHeaders)
    ? {
        firstColumn: glossaryTableHeaders[0]?.label || "Term",
        secondColumn: glossaryTableHeaders[1]?.label || "Description",
        thirdColumn: glossaryTableHeaders[2]?.label || "Solution",
      }
    : (glossaryTableHeaders as unknown as GlossaryTableHeaders) || {
        firstColumn: "Term",
        secondColumn: "Description",
        thirdColumn: "Solution",
      };

  const glossaryEntries: GlossaryEntry[] = cards
    .filter((card) => card?.data)
    .map((card) => ({
      index: card.data?.type === "Resource" ? card.data?.index || "" : "",
      headline: {
        title: card.data?.title || "",
        href: card.data?.link?.url
          ? getHrefFromCustomUrlPlugin(card.data.link.url)
          : "",
        dlt: card.data?.link?.dlt,
        dld: card.data?.link?.dld,
      },
      description: card.data?.description || "",
      solution: {
        title:
          card.data?.secondLink?.title ||
          card.data?.link?.title ||
          "Learn More",
        href: card.data?.secondLink?.url
          ? getHrefFromCustomUrlPlugin(card.data.secondLink.url)
          : card.data?.link?.url
            ? getHrefFromCustomUrlPlugin(card.data.link.url)
            : "",
        dlt: card.data?.secondLink?.dlt || card.data?.link?.dlt,
        dld: card.data?.secondLink?.dld || card.data?.link?.dld,
      },
    }));

  return (
    <ItGlossary
      glossaryEntries={glossaryEntries}
      glossaryTableHeaders={tableHeaders}
    />
  );
};
